/* eslint semi: 1 */

import { asyncFormValidation } from '@/element-ui/form-utils';
import { PageResponse } from '../player-setup-communication';
import PlayerSetupFormError from '../player-setup-form-error/player-setup-form-error-tmpl';
import CommonOptionsMixin from '@/components/mixins/common-options-mixin';
import OnEnterMixin from '@/components/mixins/onenter-mixin';
import { PLAYER_APPLICATIONS } from '../player-setup-application/player-setup-application';
import DisplayOutput from './player-setup-display-output/player-setup-display-output-tmpl.vue';
import DisplayOrientation from './player-setup-display-orientation/player-setup-display-orientation-tmpl.vue';
import DisplayResolution from './player-setup-display-resolution/player-setup-display-resolution-tmpl.vue';

export default {
  name: 'player-setup-display',
  components: {
    PlayerSetupFormError,
    DisplayOrientation,
    DisplayResolution,
    DisplayOutput
  },
  mixins: [CommonOptionsMixin, OnEnterMixin],
  props: {
    nextPage: {
      type: [String, Object, null],
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
    hasMultiOutput: {
      type: Boolean,
      default: false
    },
    applicationType: {
      type: String,
      default: null
    },
    output: {
      type: Number,
      default: 1
    },
    outputs: {
      type: Number,
      default: () => 1
    },
    resolutions: {
      type: Array,
      default: () => []
    },
    orientation: {
      type: String,
      default: 'horizontal'
    },
    resolution: {
      type: String,
      default: null
    },
    externalError: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isFormDisabled: false,
      formError: '',
      model: {
        orientation: '',
        resolution: '',
        output: 1
      },
      timezones: [],
      modelRules: {
        output: { required: true, type: 'number' },
        orientation: { required: true },
        resolution: { required: true }
      }
    };
  },
  watch: {
    output (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.output = newVal;
      }
    },
    orientation: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.model.orientation = newVal;
        }
      }
    },
    resolution (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.model.resolution = newVal;
      }
    },
    resolutions: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal && !this.model.resolution && newVal && newVal.length > 0) {
          this.model.resolution = `${newVal[0].width}x${newVal[0].height}`;
        }
      },
      deep: true
    },
    isActive: {
      immediate: true,
      handler (val) {
        if (val) {
          this.refreshForm();
        }
      }
    },
    externalError: {
      immediate: true,
      handler (val) {
        if (val) {
          this.formError = val;
        }
      }
    }
  },
  computed: {
    isMultipleDisplay () {
      return this.hasMultiOutput && [PLAYER_APPLICATIONS.APP_MIRRORING, PLAYER_APPLICATIONS.APP_LED, PLAYER_APPLICATIONS.APP_VIDEOWALL].includes(this.applicationType);
    }
  },
  methods: {
    /**
     * Remove validation results from the screen and focus primary input
     */
    refreshForm () {
      this.formError = '';
      if (this.$refs.refFormDisplay) {
        this.$refs.refFormDisplay.clearValidate();
      }
    },
    /** Trigger form submit when user hit enter */
    onEnter (event) {
      this.triggerFormSubmit();
    },
    toggleFormState (idDisabled) {
      this.isFormDisabled = idDisabled;
    },

    /**
     * This is pattern to perform form validation and easily to test it
     */
    async validateForm (validateFn = asyncFormValidation) {
      this.toggleFormState(true);
      const isFormValid = await validateFn(this.$refs.refFormDisplay);
      this.toggleFormState(false);
      return isFormValid;
    },
    async submitForm () {
      const isFormValid = await this.validateForm();

      if (!isFormValid) {
        this.formError = this.$t('label.somethingWentWrong');
        return PageResponse(true);
      }

      return PageResponse(false, this.nextPage, {
        resolution: this.model.resolution,
        orientation: this.model.orientation,
        output: this.model.output
      });
    },
    async triggerFormSubmit (event) {
      this.$emit('SubmitForm');
      return false;
    }
  }
};
